module.exports = new __parcel__URL__("filters-directory-app-skeleton.tpl.6583ea61.svg").toString();